import { ProfileCustomValuesList } from "PFApp/components/custom_values_list";
import { ProfilePreviewHeader } from "PFApp/components/profile_preview/parts/profile_preview_header";
import { ProfileCustomValue } from "PFTypes";
import { useTranslation } from "react-i18next";

type ProfilePreviewFlatSkillsProps = {
  skills: ProfileCustomValue[];
  profileId: number;
};

export const ProfilePreviewFlatSkills = ({ skills, profileId }: ProfilePreviewFlatSkillsProps) => {
  const { t } = useTranslation("core");

  return (
    <>
      {skills.length > 0 && <ProfilePreviewHeader>{t("profilePreview.skills")}</ProfilePreviewHeader>}
      <ProfileCustomValuesList
        customFieldName="skills"
        customValues={skills}
        profileId={profileId}
        limit={20}
      />
    </>
  );
};
